import React from 'react';
import hljs from 'highlight.js';
import CopyToClipboard from './CopyToClipboard';
import styles from './CodeModal.module.css';

interface CodeModalProps {
  code: string;
  onClose: () => void;
}

const CodeModal: React.FC<CodeModalProps> = ({ code, onClose }) => {
  const [open, setOpen] = React.useState(false);
  const codeRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    setTimeout(() => setOpen(true), 5);
  }, []);

  React.useEffect(() => {
    if (codeRef.current) {
      codeRef.current.removeAttribute('data-highlighted'); // 👈 rezolvă warning-ul
      hljs.highlightElement(codeRef.current);
    }
  }, [code]);

  return (
    <div className={`${styles.overlay} ${open ? styles.open : ''}`} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <CopyToClipboard codeString={code} position={'top-left'} />
        <button className={styles.closeButton} onClick={onClose}>×</button>
        <pre className={styles.codeBlock}>
          <code ref={codeRef}>{code}</code>
        </pre>
      </div>
    </div>
  );
};

export default CodeModal;
